import { render, staticRenderFns } from "./DishDetails.vue?vue&type=template&id=7ad7d44e&scoped=true&"
import script from "./DishDetails.vue?vue&type=script&lang=js&"
export * from "./DishDetails.vue?vue&type=script&lang=js&"
import style0 from "./DishDetails.vue?vue&type=style&index=0&id=7ad7d44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad7d44e",
  null
  
)

export default component.exports